import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

import useSmUp from './../hooks/useSmUp';
import mediradarIcon from './../assets/mediradar-icon.svg';

const HomePageContentStyled = styled('div')(({ theme }) => ({
   padding: theme.spacing(4),
   borderRadius: '2rem',
   background: `linear-gradient(120deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 60%, ${theme.palette.secondary.main} 100%)`,
   color: theme.palette.getContrastText(theme.palette.primary.main),
   boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.15)',
   position: 'relative',
   overflow: 'hidden',
   [theme.breakpoints.up('md')]: {
     padding: theme.spacing(8),
   }
}));

const HomePageContent = props => {
    const matches = useSmUp();

    return ( 
        <Box sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            alignItems: 'center',
            gap: 4,
        }}>
            <Box sx={{ flex: 1 }}>
                <HomePageContentStyled>
                    <Box sx={{ mb: 3, display: 'flex', ml: '-.6rem' }}>
                        <img src={mediradarIcon} alt="MediRadar Icon" style={{ height: matches ? '120px' : '60px' }} />
                    </Box>

                    <Typography 
                      variant={matches ? 'h1' : 'h3'}
                      gutterBottom 
                      sx={{
                        fontWeight: '700',
                        marginBottom: 3,
                        lineHeight: 1.2
                    }}>
                        Empowering patients Improving health
                    </Typography>
                    <Typography 
                      variant={matches ? 'h5' : 'body1'} 
                      sx={{ 
                        color: 'text.secondary', 
                        fontWeight: '400',
                        maxWidth: '600px',
                        lineHeight: 1.6
                      }}
                    >
                        Affordable access to high quality private healthcare.
                    </Typography>
                </HomePageContentStyled>                
            </Box>
        </Box>
    );
};

export default HomePageContent;